module.exports = __webpack_public_path__ + "static/media/2.6f3105ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/2.png
// module id = 760
// module chunks = 0